import { render, staticRenderFns } from "./NewYearComponent.vue?vue&type=template&id=2f6f3e30"
import script from "./NewYearComponent.vue?vue&type=script&lang=js"
export * from "./NewYearComponent.vue?vue&type=script&lang=js"
import style0 from "./NewYearComponent.vue?vue&type=style&index=0&id=2f6f3e30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports